import { NAME } from './constants.js';

export const getDomainState = (state) => state[NAME];
